import { stringSearch } from '@luminovo/design-system';
import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { NegotiationScenarioCreatePage } from '@/areas/negotiations/Negotiations/NegotiationScenarioCreatePage/NegotiationScenarioCreatePage';
import { isInternalUser } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/next/negotiations/$negotiationId/_sidebar/scenarios/create')({
    staticData: { access: { permissions: isInternalUser }, chrome: 'none' } satisfies PageStaticData,
    validateSearch: stringSearch({ demandGroupId: 'optional' }),
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const pathParams = Route.useParams();
    const demandGroupId = Route.useSearch({ select: (search) => search.demandGroupId });
    return <NegotiationScenarioCreatePage {...pathParams} demandGroupId={demandGroupId} />;
}
